import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TransitionHover from './TransitionHover';
import ClientProvider from './client';
export default createDemo(import.meta.url, TransitionHover, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/transitions/demos/hover/TransitionHover.tsx",
    "fileName": "TransitionHover.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled, createTheme, ThemeProvider } from '@mui/material/styles';\nimport { deepPurple } from '@mui/material/colors';\nimport Avatar from '@mui/material/Avatar';\n\nconst customTheme = createTheme({\n  palette: {\n    primary: {\n      main: deepPurple[500],\n    },\n  },\n});\n\nconst StyledAvatar = styled(Avatar)`\n  ${({ theme }) => `\n  cursor: pointer;\n  background-color: ${theme.palette.primary.main};\n  transition: ${theme.transitions.create(['background-color', 'transform'], {\n    duration: theme.transitions.duration.standard,\n  })};\n  &:hover {\n    background-color: ${theme.palette.secondary.main};\n    transform: scale(1.3);\n  }\n  `}\n`;\n\nexport default function TransitionHover() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={customTheme}>\n      <StyledAvatar>OP</StyledAvatar>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 33,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled, createTheme, ThemeProvider } from '@mui/material/styles';\nimport { deepPurple } from '@mui/material/colors';\nimport Avatar from '@mui/material/Avatar';\n\nconst customTheme = createTheme({\n  palette: {\n    primary: {\n      main: deepPurple[500],\n    },\n  },\n});\n\nconst StyledAvatar = styled(Avatar)`\n  ${({ theme }) => `\n  cursor: pointer;\n  background-color: ${theme.palette.primary.main};\n  transition: ${theme.transitions.create(['background-color', 'transform'], {\n    duration: theme.transitions.duration.standard,\n  })};\n  &:hover {\n    background-color: ${theme.palette.secondary.main};\n    transform: scale(1.3);\n  }\n  `}\n`;\n\nexport default function TransitionHover() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={customTheme}>\n      <StyledAvatar>OP</StyledAvatar>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "customTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "StyledAvatar"
              ],
              ">OP</",
              [
                "span",
                "pl-c1 di-jsx",
                "StyledAvatar"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 33,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/colors",
      "@mui/material/Avatar"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
